/**
 * Parse untrusted HTML into a detached, inert document body.
 *
 * Setting innerHTML on an element from document.createElement parses into the
 * live document: images load and event handlers such as `onerror` run, even
 * though the element is never attached. A document built by DOMParser has no
 * browsing context, so it loads nothing and runs no handlers.
 */
export function parseInertHtml(html: string): HTMLElement {
  return new DOMParser().parseFromString(html, 'text/html').body;
}

/** Text content of untrusted HTML, parsed inertly. Entities are decoded by the parse. */
export function inertHtmlToText(html: string): string {
  if (!html) return '';
  return parseInertHtml(html).textContent ?? '';
}
